import { render, staticRenderFns } from "./ButtonResetDialog.vue?vue&type=template&id=71b3147b&"
import script from "./ButtonResetDialog.vue?vue&type=script&lang=js&"
export * from "./ButtonResetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports